import { render, staticRenderFns } from "./RegistroPatronal.vue?vue&type=template&id=0b3549b8&scoped=true"
import script from "./RegistroPatronal.vue?vue&type=script&lang=js"
export * from "./RegistroPatronal.vue?vue&type=script&lang=js"
import style0 from "./RegistroPatronal.vue?vue&type=style&index=0&id=0b3549b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3549b8",
  null
  
)

export default component.exports